import React from "react";
import PropTypes from "prop-types";
import { withLocalize } from "react-localize-redux";
import ClassStartList from "./ClassStartList";
import ClassResultList from "./ClassResultList";
import ListType from "../../../logic/models/ListType";

const ResultSelectionExtract = ({ event, listType, isMultiRace, classResultLists }) => {
    return (
        <>
            {
                listType === ListType.startList && classResultLists.map(classResultList => <ClassStartList key={`${classResultList.cl.classId}-${classResultList.results[0]?.raceId}`} event={event} showRaceNumber={isMultiRace} {...classResultList} />)
            }
            {
                listType !== ListType.startList && classResultLists.map(classResultList => <ClassResultList key={`${classResultList.cl.classId}-${classResultList.results[0]?.raceId}`} event={event} showRaceNumber={isMultiRace} {...classResultList} />)
            }
        </>
    );
};

ResultSelectionExtract.propTypes = {
    event: PropTypes.object.isRequired,
    listType: PropTypes.number.isRequired,
    isMultiRace: PropTypes.bool,
    classResultLists: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired
};

export default withLocalize(ResultSelectionExtract);